/* eslint-disable no-undef */
import { Stores, Analytics, Api } from "arv-extends";
import { action } from "mobx";
import {
  CORPORATE_GIFTING_COMPONENTS,
  CIRCLE_PROGRAM,
  WARRANTY_EXTENSION_COMPONENT,
} from "npmlinks-constants";

const { LogMan } = Analytics;

class CommonActions extends Stores.CommonStoreClass {
  @action
  triggerCorporateGifting(data) {
    console.log(this);
    const finalData = {
      name: data.name,
      email: data.email,
      mobile_number: data.mobileNo,
      company_name: data.company,
      city: data.city,
      remark: data.remark,
      pincode: data.pincode,
      quantity: data.quantity,
    };
    const emailRequest = {
      templateId:
        CORPORATE_GIFTING_COMPONENTS.MESSAGE_TRIGGER_PARAMS.templateId,
      from: CORPORATE_GIFTING_COMPONENTS.MESSAGE_TRIGGER_PARAMS.from,
      to: [process.env.REACT_APP_CORPOTATEGIFTING_MAILID],
      bcc: [],
      subject: CORPORATE_GIFTING_COMPONENTS.MESSAGE_TRIGGER_PARAMS.subject,
      data: finalData,
      message: CORPORATE_GIFTING_COMPONENTS.MESSAGE_TRIGGER_PARAMS.message,
      mode: "email",
    };

    const finalPromises = [
      Api.post("triggerMail", {}, JSON.stringify(emailRequest)),
      LogMan.trackLog(
        Object.assign({}, emailRequest, {
          logmanEventName: "corporate_gifting",
        }),
      ),
    ];

    return new Promise((resolve, reject) => {
      Promise.all(finalPromises).then(
        () => {
          resolve();
        },
        () => {
          reject();
        },
      );
    });
  }

  @action
  triggerCircleProgram(data) {
    console.log(this);
    const finalData = {
      name: data.name,
      email: data.email,
      mobile_number: data.mobileNo,
      whatsapp_number: data.whatsapp_number,
      pincode: data.pincode,
      whatsAppNotificationAccepted: data.isReciveUpdatesChecked,
      dateOfBirth: data.dateOfBirth,
      selectedTitle: data.selectedTitle,
    };
    const emailRequest = {
      templateId: CIRCLE_PROGRAM.MESSAGE_TRIGGER_PARAM2.templateId,
      from: process.env.REACT_APP_CIRCLE_PROGRAM_DETAILS_MAIL_ID,
      to: [data.email],
      bcc: [],
      subject: CIRCLE_PROGRAM.MESSAGE_TRIGGER_PARAM2.subject,
      data: { name: data.name },
      message: CIRCLE_PROGRAM.MESSAGE_TRIGGER_PARAM2.message,
      mode: "email",
    };

    const smsRequest = {
      templateId: CIRCLE_PROGRAM.MESSAGE_TRIGGER_PARAM3.templateId,
      to: [data.mobileNo],
      bcc: [],
      data: { name: data.name },
      message: CIRCLE_PROGRAM.MESSAGE_TRIGGER_PARAM2.message,
      mode: "sms",
    };

    const formRequest = {
      formName: CIRCLE_PROGRAM.GENERIC_FORM_NAME,
      data: finalData,
    };

    const finalPromises = [
      Api.post("triggerMail", {}, JSON.stringify(emailRequest)),
      Api.post("triggerMail", {}, JSON.stringify(smsRequest)),
      Api.post("genericForm", {}, JSON.stringify(formRequest)),
    ];

    return new Promise((resolve, reject) => {
      Promise.all(finalPromises).then(
        () => {
          resolve();
        },
        () => {
          reject();
        },
      );
    });
  }

  @action
  triggerWarrantyExtension(data) {
    console.log(this);
    const request = {
      formName: WARRANTY_EXTENSION_COMPONENT.FORM_NAME,
      data,
    };
    const emailRequest = {
      templateId: WARRANTY_EXTENSION_COMPONENT.EMAIL.templateId,
      from: WARRANTY_EXTENSION_COMPONENT.EMAIL.from,
      to: [data.email],
      bcc: [],
      subject: WARRANTY_EXTENSION_COMPONENT.EMAIL.subject,
      data: { name: data.name },
      message: CIRCLE_PROGRAM.MESSAGE_TRIGGER_PARAM2.message,
      mode: "email",
    };

    const smsRequest = {
      templateId: WARRANTY_EXTENSION_COMPONENT.SMS.templateId,
      to: [data.mobileNo],
      bcc: [],
      data: { name: data.name },
      message: CIRCLE_PROGRAM.MESSAGE_TRIGGER_PARAM2.message,
      mode: "sms",
    };

    const finalPromises = [
      Api.post("triggerMail", {}, JSON.stringify(emailRequest)),
      Api.post("triggerMail", {}, JSON.stringify(smsRequest)),
      Api.post("genericForm", {}, JSON.stringify(request)),
    ];
    return new Promise((resolve, reject) => {
      Promise.all(finalPromises).then(
        () => {
          resolve();
        },
        err => {
          console.log("error triggerWarrantyExtension ====>", err);
          reject();
        },
      );
    });
  }
}

export default CommonActions;
